import * as yup from "yup";

export const loginSchema = yup.object({
  email: yup.string("Enter a valid email").email("Must be a valid email").required("Email is required"),
  password: yup
    .string("Enter a valid password")
    .required("Password is required"),
});
